import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function Shell() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    // On desktop (md and up), sidebar is open by default
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 768;
    }
    return true;
  });

  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 768;
    }
    return true;
  });

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 768;
      setIsDesktop(desktop);
      // On mobile, close sidebar; on desktop, open by default if it was closed
      if (desktop && !isSidebarOpen) {
        setIsSidebarOpen(true);
      } else if (!desktop) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <Container fluid className="vh-100 p-0 position-relative">
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div
        style={{
          marginLeft: isDesktop ? (isSidebarOpen ? '280px' : '0') : '0',
          transition: 'margin-left 0.3s ease-in-out',
          width: isDesktop
            ? isSidebarOpen
              ? 'calc(100% - 280px)'
              : '100%'
            : '100%',
          minHeight: '100vh',
        }}
        className="bg-light"
      >
        <Topbar onMenuToggle={toggleSidebar} />
        <div className="p-4 pb-5">
          <Outlet />
        </div>
      </div>
    </Container>
  );
}

